import React from "react";
import {ActionRowDropdownButton, DropdownItem, DropdownItemGroup, DropdownItemGroups, Icon} from "peggirkit";
import {CheckIcon, FunnelIcon} from "@heroicons/react/24/outline";
import {FormattedMessage, IntlShape} from "react-intl";
import {SetURLSearchParams} from "react-router-dom";
import {ApplyTooltipFn} from "@widgets/tooltip/TooltipProvider";
import { ClockedFilterStatus } from "../Employees";


const clockedStatusFilterParam = "status";
const clockedStatusFilterParamClockedIn = "clocked-in";
const clockedStatusFilterParamClockedOut = "clocked-out";

export const searchParamsToStatusFilter = (searchParams: URLSearchParams): ClockedFilterStatus => {
    const searchParam = searchParams.get(clockedStatusFilterParam);
    switch (searchParam) {
        case clockedStatusFilterParamClockedIn:
            return ClockedFilterStatus.CLOCKED_IN;
        case clockedStatusFilterParamClockedOut:
            return ClockedFilterStatus.CLOCKED_OUT;
        default:
            return ClockedFilterStatus.ALL;
    }
};

const setStatusFilter = (updated: ClockedFilterStatus, setSearchParams: SetURLSearchParams) => {
    setSearchParams(p => {
        switch (updated) {
            case ClockedFilterStatus.ALL:
                p.delete(clockedStatusFilterParam);
                break;
            case ClockedFilterStatus.CLOCKED_IN:
                p.set(clockedStatusFilterParam, clockedStatusFilterParamClockedIn);
                break;
            case ClockedFilterStatus.CLOCKED_OUT:
                p.set(clockedStatusFilterParam, clockedStatusFilterParamClockedOut);
                break;
        }

        return p;
    })
};

type Props = {
    statusFilter: ClockedFilterStatus,
    setSearchParams: SetURLSearchParams,
    applyTooltip: ApplyTooltipFn,
    intl: IntlShape,
};

const clockedStatusFilter = ({statusFilter, setSearchParams, applyTooltip, intl}: Props) => {
    return (
        <ActionRowDropdownButton
            showInRowBreakpoint={"md"}
            color={"secondary"}
            iconBefore={<Icon icon={FunnelIcon}/>}
            props={{
                ...applyTooltip(intl.formatMessage({id: "filterOnClocked"})),
            }}
            items={
                <DropdownItemGroups>
                    <DropdownItemGroup>
                        <DropdownItem
                            icon={statusFilter === ClockedFilterStatus.ALL ? <Icon icon={CheckIcon}/> : "empty"}
                            disabled={statusFilter === ClockedFilterStatus.ALL}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: () => setStatusFilter(ClockedFilterStatus.ALL, setSearchParams),
                                },
                            }}
                        >
                            <FormattedMessage id={"showAll"}/>
                        </DropdownItem>
                    </DropdownItemGroup>

                    <DropdownItemGroup>
                        <DropdownItem
                            icon={
                                statusFilter === ClockedFilterStatus.CLOCKED_IN
                                    ? <Icon icon={CheckIcon}/>
                                    : "empty"
                            }
                            disabled={statusFilter === ClockedFilterStatus.CLOCKED_IN}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: () => setStatusFilter(ClockedFilterStatus.CLOCKED_IN, setSearchParams),
                                },
                            }}
                        >
                            <FormattedMessage id={"clockedIn"}/>
                        </DropdownItem>
                        <DropdownItem
                            icon={
                                statusFilter === ClockedFilterStatus.CLOCKED_OUT
                                    ? <Icon icon={CheckIcon}/>
                                    : "empty"
                            }
                            disabled={statusFilter === ClockedFilterStatus.CLOCKED_OUT}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: () => setStatusFilter(ClockedFilterStatus.CLOCKED_OUT, setSearchParams),
                                },
                            }}
                        >
                            <FormattedMessage id={"clockedOut"}/>
                        </DropdownItem>
                    </DropdownItemGroup>
                </DropdownItemGroups>
            }
            selected={statusFilter !== ClockedFilterStatus.ALL}
        >
            <FormattedMessage id={statusFilter === ClockedFilterStatus.ALL ? "showAll" : statusFilter}/>
        </ActionRowDropdownButton>
    );
};

export default clockedStatusFilter;